import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { StyleServiceService } from '@app/finxone-web-frontend/app/lib/services/style-service/style-service.service';
import { WorkflowFormsService } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-forms.service';
import { CardState } from '@app/finxone-web-frontend/app/lib/state/card.state';
import { setCssAttributes } from '@app/finxone-web-frontend/app/lib/utils/utils';
import {
  CardInfoType,
  FormFieldConfig,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-card-name-widget',
  templateUrl: './card-name-widget.component.html',
  styleUrls: ['./card-name-widget.component.scss'],
})
export class CardNameWidgetComponent implements OnInit, OnDestroy {
  public attri: UiZoneWidgetAttributeConfig;

  private contentStyle: baseCssConfigStyle;
  private textInputBackgroundColor: baseCssConfigStyle;
  public borderStyle: baseCssConfigStyle;

  public form: FormGroup;

  public validationConfig = [
    {
      type: 'required',
      message: 'Card name is required',
    },
    {
      type: 'maxlength',
      message: 'Please enter a nickname with fewer than 20 characters',
      params: 20,
    },
  ];

  private cardNameFormDef: FormFieldConfig = {
    type: 'text',
    name: 'cardName',
    label: 'Card Name',
    validation: {
      required: true,
      maxLength: 20,
    },
    defaultValue: '',
  };

  private currentCardData: CardInfoType;
  private formPath: string;

  constructor(
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private workflowFormsService: WorkflowFormsService,
    private configService: ConfigService,
    private styleService: StyleServiceService,
    private store: Store,
  ) {
    this.formPath = this.dataIn.attri.workflowFormConfig?.formPath ?? 'cards.cardName';
    this.setInternalVariables();
  }

  ngOnInit(): void {
    this.getRhsProperty();
    this.setFormData();
  }

  private setFormData() {
    this.currentCardData = this.store.selectSnapshot(CardState.getCurrentCardDetail);
    if (this.currentCardData && this.currentCardData.name) {
      this.cardNameFormDef.defaultValue = this.currentCardData.name;
    }
    this.workflowFormsService.createForm(this.formPath, [this.cardNameFormDef]);
    this.form = this.workflowFormsService.getFormPart(this.formPath) as FormGroup;
  }

  private setInternalVariables() {
    if (this.dataIn != undefined && this.dataIn != null) {
      this.attri = this.dataIn.attri;
    }
  }

  private getRhsProperty() {
    const { contentStyle, borderStyle, textInputBackgroundColor } = setCssAttributes(
      this.styleService,
      this.configService,
      this.attri,
    );
    this.contentStyle = contentStyle;
    this.borderStyle = borderStyle;
    this.textInputBackgroundColor = textInputBackgroundColor;
  }

  public getOuterStyles() {
    return {
      ...this.textInputBackgroundColor,
      ...this.contentStyle,
      ...this.borderStyle,
    };
  }

  ngOnDestroy(): void {
    this.workflowFormsService.resetForm(this.formPath);
  }
}
